import { Routes } from '@angular/router';
import { authGuard, completeProfileGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/store/store.page').then(m => m.StorePage),
    //loadComponent: () => import('./tabs/events/events.page').then(m => m.EventsPage),
  },
  {
    path: 'cart',
    loadComponent: () => import('./pages/shopping-cart/shopping-cart.page').then(m => m.ShoppingCartPage),
  },
  {
    path: 'checkout',
    loadComponent: () => import('./pages/checkout/checkout.page').then(m => m.CheckoutPage),
    canActivate: [authGuard, completeProfileGuard],
  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile.page').then(m => m.ProfilePage),
    canActivate: [authGuard],
  },
  {
    path: 'edit-basic-profile',
    loadComponent: () => import('./pages/edit-basic-profile/edit-basic-profile.page').then(m => m.EditBasicProfilePage),
    canActivate: [authGuard],
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(m => m.routes)
  },
  {
    path: 'rules',
    loadComponent: () => import('./pages/rules-and-terms/rules-and-terms.page').then(m => m.RulesAndTermsPage),
  },
  {
    path: 'event/:id',
    loadComponent: () => import('./pages/event-single-view/event-single-view.page').then(m => m.EventSingleViewPage),
  },
  {
    path: 'cart',
    loadComponent: () => import('./pages/shopping-cart/shopping-cart.page').then(m => m.ShoppingCartPage),
  },
  {
    path: 'cart/add-partner',
    loadComponent: () => import('./pages/shopping-cart-couple-tickets/shopping-cart-couple-tickets.page').then(m => m.ShoppingCartCoupleTicketsPage),
    canActivate: [completeProfileGuard],
  },
  {
    path: 'membership/payment',
    loadComponent: () => import('./pages/membership-payment/membership-payment.page').then(m => m.MembershipPaymentPage),
    canActivate: [authGuard, completeProfileGuard],
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full'
  }
];
